import Auth from '@/pages/Auth';

// Portal-scoped auth — renders the same Auth component
// but within the portal context (PortalLayout provides the context)
const PortalAuth = () => <Auth />;

export default PortalAuth;
